import React from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useHistory } from "react-router-dom";
import "./styles.scss";

import ExternalShare from "../../../shared/Svg/ExternalShare";
import HeartOutline from "../../../shared/Svg/HeartOutline";
import HeartFilled from "../../../shared/Svg/HeartFilled";
import Menu from "../../PostsList/Post/PostHeader/Menu";
import hv_player_api from "../../../../api/hv_player_api";
import { unlike, like } from "../../../../api/likes";
import { log_error } from "../../../../api";
import defaultAlbumImg from "../../../../public/images/default-alblum-img.png";

export default ({ isActive, currently_playing, landingPage }) => {
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 768px)",
  });

  return !isActive ? (
    <div></div>
  ) : (
    <div className="d-flex align-items-center">
      <div className="media">
        <img
          width={50}
          height={50}
          src={currently_playing.preview_image ? currently_playing.preview_image.url : defaultAlbumImg}
          alt={"preview_image"}
          className="mr-2 my-auto"
        />
        <div className="text-white">
          {landingPage ? (
            <a className="user-link player-title-wrap" href={`/${currently_playing.user && currently_playing.user.slug}`}>
              {currently_playing.title || (currently_playing.user && currently_playing.user.username)}
            </a>
          ) : (
            <Link className="user-link player-title-wrap" to={`/${currently_playing.user && currently_playing.user.slug}`}>
              {currently_playing.title || (currently_playing.user && currently_playing.user.username)}
              {/* {currently_playing.user && currently_playing.user.username} */}
            </Link>
          )}
          <p
            style={{
              margin: 0,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {landingPage ? (
              <a className="user-link track-title" href={`/${currently_playing.user && currently_playing.user.slug}`}>
                {currently_playing.user && currently_playing.user.username}
              </a>
            ) : (
              <Link className="user-link track-title" to={`/${currently_playing.user && currently_playing.user.slug}`}>
                {currently_playing.user && currently_playing.user.username}
              </Link>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
